import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaCalendarAlt,
  FaClock,
  FaUsers,
  FaGraduationCap,
  FaInfoCircle,
  FaBuilding,
  FaHandshake,
  FaMapMarkerAlt,
  FaUtensils,
  FaHeart,
  FaCoffee,
  FaComments,
  FaSchool,
} from 'react-icons/fa';

const ICON_MAP = {
  user: FaUser,
  envelope: FaEnvelope,
  phone: FaPhone,
  calendar: FaCalendarAlt,
  clock: FaClock,
  users: FaUsers,
  graduation: FaGraduationCap,
  info: FaInfoCircle,
  building: FaBuilding,
  handshake: FaHandshake,
  map: FaMapMarkerAlt,
  utensils: FaUtensils,
  heart: FaHeart,
  coffee: FaCoffee,
  comments: FaComments,
  school: FaSchool,
};

export function getFormIcon(iconKey) {
  const Icon = ICON_MAP[iconKey];
  return Icon ? <Icon /> : null;
}
